import "../scss/contact.scss";
import "./commonUtility.js";

const form = document.querySelector("form");
const button = form.querySelector("button");

form.addEventListener("submit", async (e) => {
  e.preventDefault();

  if (form.hidden && form.hidden.value) return;

  // Block repeat submissions this session
  if (document.cookie.includes("formSubmitted=true")) {
    alert("You already sent a message this session.");
    form.reset();
    return;
  }

  const name = form.name.value;
  const email = form.email.value;
  const message = form.message.value;
  if (!name || !email || !message) {
    alert("Please fill in all fields.");
    return;
  }

  button.disabled = true;

  try {
    const response = await fetch("https://idrisscissoko.com/api/message", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, message }),
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    document.cookie = "formSubmitted=true; path=/; SameSite=Lax";
    alert("Message sent successfully! I'll get back to you soon.");
    form.reset();
  } catch (err) {
    alert(err.message || "Something went wrong. Please try again.");
  } finally {
    button.disabled = false;
  }
});
